import TokenService from "@/services/token.service"

export const getUserFromToken = token => {
  const decodedToken = TokenService.getDecodedToken(token) || {}
  const user = {
    name: decodedToken.sub,
  }
  return user
}
